<template>
    <div id='ItemCard' class='row'>
        <div v-if="!mySku">
            <h2>Please Search for a Sku Above</h2>
        </div>
        <div v-if="mySku" class='SinglePane col-12'>
            <PaneHeader
                :product='thisProduct'
                :cardType='ItemCardType'
            />
            <div class='pane-content row'>
                <ProductDetails 
                    :name='thisProduct'
                    :sku='mySku'
                    :images='defaultImages'
                    :pricing='myPricing'
                    :id='id'
                    v-if='ItemCardType == "ItemCard"'
                />
            </div>
        </div>
        <div v-if="mySku" class='SinglePane col-12'>
            <PaneHeader
                :product='thisProduct'
                :cardType='ItemHistoryType'
            />
            <ItemHistory 
                :sku='mySku'
            />
        </div>
    </div>
    
</template>

<script>
    import PaneHeader from '../../core/layout/PaneHeader.vue'
    import ProductDetails from './ProductDetails'
    import ItemHistory from '../../widget/Report/ItemHistory'
    export default {
        name: 'ItemCard',
        components: {
            PaneHeader,
            ProductDetails,
            ItemHistory
        },
        mounted(){
            //this.$api.get('/api/itemCard/sku/QNB0PBHEPH006').then((response) => console.log(response))
            //this.$store.dispatch('ItemCard/fetchItem', 'QNB0PBHEPH006')
        },
        data() {
            return{
                
                myPricing: this.$store.getters['ItemInfo/pricing'], 
                id: this.$store.getters['ItemInfo/id'],  
                ItemCardType: 'ItemCard',
                ItemHistoryType: 'ItemHistory',
                defaultImages: this.$store.getters['ItemInfo/defaultImages']
            }
        },
        computed:{
            mySku() {
                return this.$store.getters['ItemInfo/productSku']
            },
            thisProduct(){ 
                return {
                    name: this.$store.getters['ItemInfo/productName']
                }
            }
        }
    }
</script>
